<template>
  <div
    class="flex flex-col justify-between py-10 px-14 rounded-md mx-auto uploader-container"
    ref="droptarget"
    :id="`resumable-${group}`"
    @dragover="isDragging = true"
    @dragleave="isDragging = false"
  >
    <div class="text-center mb-4">
      <h1 class="text-xl font-normal title" v-text="label"></h1>
      <!-- <h2 class="text-lg font-semibold mb-4" v-text="label"></h2> -->
    </div>
    <div class="mb-4 pointer-events-none">
      <DropTarget label="label" :show-label="false" :show-dropin="true" v-if="!hasFiles" />
      <div class="" v-else>
        <div class="flex items-center justify-between mb-4" v-for="(file, index) in files" :key="index">
          <div class="bg-gradient-gray-500 shadow-md flex-auto mr-2 pl-2 pr-8 py-1 border-1 rounded-lg">
            <p class="" v-text="file.name"></p>
            <div>
              <ts-progress
                v-if="isFileUploading(file)"
                :percentage="file.resumableFile.tsUploadProgress * 100"
              ></ts-progress>
            </div>
          </div>
          <div class="">
            <ts-button size="small" class="pointer-events-auto" circle @click.prevent="removeFile(file)">
              <ts-icon icon="trash" size="x-small" color="#6d7587" />
            </ts-button>
          </div>
        </div>
      </div>
    </div>
    <div class="pointer-events-none" v-if="!hasFiles">
      <p class="mb-2 text-center label">Drag and drop</p>
      <div class="flex mb-2 items-center">
        <ts-divider></ts-divider>
        <p class="flex-none px-2 font-normal">Or</p>
        <ts-divider></ts-divider>
      </div>
    </div>
    <div class="inline-flex items-center justify-center" ref="droptargetPlaceholder">
      <div class="flex mb-2 items-center" v-if="hasFiles">
        <ts-divider></ts-divider>
        <div class="">
          <ts-button size="small" filled> Add file </ts-button>
        </div>
        <ts-divider></ts-divider>
      </div>
      <ts-button type="primary" size="normal" filled v-else> Import file </ts-button>
    </div>
  </div>
</template>

<script>
import DropTarget from '@/components/DropTarget.vue';
import projectViewHelpers from '@/mixins/projectViewHelpers';

export default {
  mixins: [projectViewHelpers],
  components: {
    DropTarget
  },
  props: {
    files: {
      type: Array,
      default: () => []
    },
    resumable: {
      type: Object,
      required: true
    },
    label: {
      type: String,
      default: 'Upload file'
    },
    group: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isDragging: false
    };
  },
  computed: {
    hasFiles() {
      return this.files.length > 0;
    }
  },
  methods: {
    isFileUploading(file) {
      return file.resumableFile && file.resumableFile.tsIsUploading && !file.resumableFile.tsIsComplete;
    },
    removeFile(file) {
      this.$emit('removed', file);
    }
  },
  mounted() {
    this.resumable.assignBrowse(this.$refs.droptargetPlaceholder);
    this.resumable.assignDrop(this.$refs.droptarget);
    this.resumable.on('fileAdded', (file, { target }) => {
      if (!target || !target.closest(`#resumable-${this.group}`)) {
        return;
      }

      this.$emit('added', {
        name: file.fileName,
        resumableFile: file,
        type: 'uploaded-file',
        group: this.group
      });
    });
  }
};
</script>

<style scoped lang="scss">
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.rounded-md {
  border-radius: 10px;
}
.px-14 {
  padding-left: 3.5rem;
  padding-right: 3.5rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.flex-col {
  flex-direction: column;
}
.uploader-container {
  box-shadow: 2px 2px 6px 0 rgba(166, 171, 189, 0.24);
  border: solid 2px rgba(255, 255, 255, 0.16);
}
.items-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
.label {
  font-family: Roboto;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #6d7587;
}
.title {
  font-family: Roboto;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: center;
  color: #6d7587;
}
.text-center {
  text-align: center;
}
.text-xl {
  font-size: 1.3rem;
  font-weight: 500;
  text-align: center;
}
.pointer-events-auto {
  pointer-events: auto;
}
.pointer-events-none {
  pointer-events: none;
}
.inline-flex {
  display: inline-flex;
}
.flex {
  display: flex;
}
.flex-auto {
  flex: auto;
}
.bg-gradient-gray-500 {
  background-blend-mode: soft-light, normal;
  background-image: linear-gradient(278deg, #000000, var(--fills-neutral-white) 0%),
    linear-gradient(to bottom, #ebecf0, #ebecf0);
}
.border-1 {
  border: solid 2px rgba(255, 255, 255, 0.32);
}
.shadow-md {
  box-shadow: 6px 6px 16px 0 rgba(166, 171, 189, 0.4), -6px -6px 16px 0 rgba(250, 251, 255, 0.4);
}
.rounded-lg {
  border-radius: 24px;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.pr-8 {
  padding-left: 1.75rem;
}
.pl-2 {
  padding-right: 0.75rem;
}
.mr-2 {
  margin-right: 1.5rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mx-auto {
  margin: 0 auto;
}
</style>